import React from "react";
import { Button } from "react-md";
import errorImg from "../../../../../../../assets/icons/payment/error_red_exclamation.svg";
import successGif from "../../../../../../../assets/images/done-animation.gif";

const AptCreatedButLinkNotGenerated = ({ appointmentCreated, props }) => {
  return (
    <div
      className="pld-screen pld-method-container"
      style={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
      }}
    >
      {/* SUCCESS GIF */}
      <div style={{ marginTop: "25px" }}>
        <img src={successGif} alt="success" height="170px" />
      </div>

      {/* TITLE */}
      <div style={{ fontWeight: "bold", fontSize: "22px", margin: "10px 0px" }}>
        Appointment created successfully!
      </div>

      <div className="zy-dashed-border">
        {/* ERROR IMAGE */}
        <div>
          <img src={errorImg} alt="error" height="50px" />
        </div>

        {/* NOTE BOX */}
        <div className="pld-note-container" style={{ marginTop: "15px" }}>
          <div className="pld-note-box">
            <span className="pld-bold">Error in generating payment link</span>
          </div>
        </div>

        {/* BUTTON */}
        <div className="pld-center" style={{ marginTop: "10px" }}>
          <Button
            raised
            className="zy-btn-orange pld-main-btn"
            onClick={() => {
              props.setView(2, {
                appId: appointmentCreated?.id,
              });
            }}
          >
            Try generating link again
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AptCreatedButLinkNotGenerated;
